import { Link } from 'react-router-dom';

export default function ContactCTA() {
  return (
    <section className="w-full px-6 md:px-10 py-16 md:py-20 relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Modern%20office%20with%20warm%20ambient%20lighting%20global%20business%20atmosphere%20with%20world%20map%20on%20glass%20wall%20elegant%20corporate%20interior%20professional&width=1800&height=600&seq=cta-bg-2025&orientation=landscape"
          alt="征途国际 联系我们"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/85 to-foreground-950/65"></div>

      <div className="relative z-10 max-w-3xl mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-bold text-background-50 font-heading mb-4">
          准备好开启您的全球征途了吗？
        </h2>
        <p className="text-sm md:text-base text-background-50/70 mb-8 max-w-lg mx-auto leading-relaxed">
          立即联系征途国际的专业顾问团队，让我们为您的企业量身定制国际化解决方案
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/about#contact"
            className="px-8 py-3 bg-primary-500 text-background-50 font-medium rounded-md hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer text-sm"
          >
            免费咨询
          </Link>
          <a
            href="tel:+864008889999"
            className="px-8 py-3 border border-background-50/30 text-background-50 font-medium rounded-md hover:bg-background-50/10 transition-colors whitespace-nowrap cursor-pointer text-sm"
          >
            拨打电话：400-888-9999
          </a>
        </div>
      </div>
    </section>
  );
}